const daycareApiHost = process.env.REACT_APP_DAYCARE_API_HOST;
const daycareApiVersion = process.env.REACT_APP_DAYCARE_API_VERSION;

const daycareApiRoot = 'https://' + daycareApiHost + '/v' + daycareApiVersion;

export { daycareApiRoot };

export class APIBaseError extends Error {
  status: number;

  constructor(status: number, e?: string) {
    super(e);
    this.status = status;
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class BadRequestError extends APIBaseError {
  constructor(message: string) {
    super(400, message);
  }
}

export class UnauthorizedError extends APIBaseError {
  constructor(message: string) {
    super(403, message);
  }
}

export class NotFoundError extends APIBaseError {
  constructor(message: string) {
    super(404, message);
  }
}

export class ConflictError extends APIBaseError {
  constructor(message: string) {
    super(409, message);
  }
}

export class InternalServerError extends APIBaseError {}

// レコード管理API
export const yogaApiRoot = process.env.REACT_APP_YOGA_API_URL || '';
export const homevisitApiRoot = process.env.REACT_APP_HOMEVISIT_API_URL || '';
export const interestApiRoot = process.env.REACT_APP_INTEREST_API_URL || '';
export const mciApiRoot = process.env.REACT_APP_MCI_API_URL || '';
export const lifecheckApiRoot = process.env.REACT_APP_LIFECHECK_API_URL || '';
export const barthelApiRoot = process.env.REACT_APP_BARTHEL_API_URL || '';
